import Popper from "@mui/material/Popper";

const AutocompletePopperComponent = function (props) {
  return <Popper {...props} style={{ width: "auto" }} placement="top-start" />;
};

export default AutocompletePopperComponent;
